import * as React from 'react';
import cssStyles from './index.scss';

export interface Props {
  ctaLabel: string;
  ctaLabelColor: string;
  ctaBackgroundColor: string;
  onClick: (e: React.MouseEvent<Element, MouseEvent>) => void;
}

/**
 * Use `Cta` to display a cta button
 */
export function Cta({
  ctaLabel,
  ctaLabelColor,
  ctaBackgroundColor,
  onClick
}: Props) {
  return (
    <div id="cta-layer" className={cssStyles.ctaLayer}>
      <div
        className={cssStyles.ctaButton}
        style={{
          backgroundColor: ctaBackgroundColor
        }}
      >
        <div className={cssStyles.ctaLabel} style={{ color: ctaLabelColor }}>
          {ctaLabel}
        </div>
      </div>
      <div className={cssStyles.ctaClickZone} onClick={onClick} />
    </div>
  );
}
